import infoBoard from '../infoboard';
import sideBar from '../sidebar';

const searchBox = () =>
    [{
        element: '#searchbox-input',
        title: 'Barra de Pesquisa',
        content: 'Você pode buscar lojas, pontos de interesse ou áreas utilizando a busca do NeoGIG.',
        placement: 'bottom',
        onShow () {
            sideBar.close();
            infoBoard.open();
        },
        onHide () {
            infoBoard.close();
        }
    }];

export default searchBox;



// WEBPACK FOOTER //
// ./src/scripts/core/tour/searchbox.js